import React from 'react';

interface XRPLProofsProps {
  isMobile: boolean;
}

const XRPLProofs: React.FC<XRPLProofsProps> = ({ isMobile }) => {
  const accounts = [
    {
      title: 'XRPL Issuer / Gateway',
      address: 'rpP12ND2K7ZRzXZBEUnQM2i18tMGytXnW1',
      url: 'https://livenet.xrpl.org/accounts/rpP12ND2K7ZRzXZBEUnQM2i18tMGytXnW1',
      xrpscanUrl: 'https://xrpscan.com/account/rpP12ND2K7ZRzXZBEUnQM2i18tMGytXnW1',
      description: 'Primary USDT issuer with $185M+ verified capacity'
    }
  ];

  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: isMobile ? '100px 20px 60px' : '140px 48px 80px'
    }}>
      <div style={{
        fontSize: isMobile ? '32px' : '48px',
        fontWeight: '300',
        marginBottom: '16px',
        background: 'linear-gradient(180deg, #ffffff 0%, #e5e7eb 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      }}>
        XRPL Proofs
      </div>

      <div style={{
        fontSize: '16px',
        color: '#9ca3af',
        marginBottom: '48px',
        lineHeight: '1.6',
        maxWidth: '800px'
      }}>
        UNYKORN operates on the XRP Ledger with transparent, verifiable accounts. All trust lines, balances, and transaction history are publicly auditable on the XRPL mainnet.
      </div>

      {/* Issuer Account */}
      <div style={{
        padding: isMobile ? '28px' : '40px',
        background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.6) 0%, rgba(15, 23, 42, 0.3) 100%)',
        border: '1px solid rgba(59, 130, 246, 0.2)',
        borderRadius: '16px',
        marginBottom: '32px'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          marginBottom: '24px',
          color: '#ffffff'
        }}>
          🔐 XRPL Gateway Account
        </h2>

        {accounts.map((account, i) => (
          <div key={i} style={{
            padding: '24px',
            background: 'rgba(0, 0, 0, 0.3)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '12px'
          }}>
            <div style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#60a5fa',
              marginBottom: '12px'
            }}>
              {account.title}
            </div>
            <div style={{
              fontSize: '14px',
              color: '#9ca3af',
              marginBottom: '16px',
              lineHeight: '1.6'
            }}>
              {account.description}
            </div>
            <div style={{
              fontFamily: 'monospace',
              fontSize: '13px',
              color: '#e5e7eb',
              padding: '12px',
              background: 'rgba(0, 0, 0, 0.4)',
              borderRadius: '8px',
              marginBottom: '16px'
            }}>
              {account.address}
            </div>

            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <a
                href={account.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '10px 18px',
                  background: 'rgba(59, 130, 246, 0.15)',
                  border: '1px solid rgba(59, 130, 246, 0.3)',
                  borderRadius: '8px',
                  color: '#60a5fa',
                  fontSize: '14px',
                  fontWeight: '600',
                  textDecoration: 'none',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(59, 130, 246, 0.25)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(59, 130, 246, 0.15)';
                }}
              >
                View on Livenet →
              </a>
              <a
                href={account.xrpscanUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '10px 18px',
                  background: 'rgba(16, 185, 129, 0.15)',
                  border: '1px solid rgba(16, 185, 129, 0.3)',
                  borderRadius: '8px',
                  color: '#10b981',
                  fontSize: '14px',
                  fontWeight: '600',
                  textDecoration: 'none',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(16, 185, 129, 0.25)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(16, 185, 129, 0.15)';
                }}
              >
                View on XRPScan →
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Capacity Card */}
      <div style={{
        padding: isMobile ? '28px' : '40px',
        background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(15, 23, 42, 0.3) 100%)',
        border: '1px solid rgba(16, 185, 129, 0.2)',
        borderRadius: '16px',
        marginBottom: '32px'
      }}>
        <div style={{
          fontSize: '20px',
          fontWeight: '600',
          color: '#10b981',
          marginBottom: '16px'
        }}>
          Available Capacity
        </div>
        <div style={{
          fontSize: isMobile ? '36px' : '48px',
          fontWeight: '700',
          color: '#ffffff',
          marginBottom: '8px'
        }}>
          $185,000,000 USDT
        </div>
        <div style={{
          fontSize: '14px',
          color: '#9ca3af'
        }}>
          Verified trust line capacity on XRPL mainnet
        </div>
      </div>

      {/* Verification Badge */}
      <div style={{
        padding: '24px',
        background: 'rgba(59, 130, 246, 0.05)',
        border: '1px solid rgba(59, 130, 246, 0.2)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '14px',
          color: '#60a5fa',
          fontWeight: '600',
          marginBottom: '8px'
        }}>
          ✓ VERIFIED ON XRPL MAINNET
        </div>
        <div style={{
          fontSize: '13px',
          color: '#9ca3af',
          lineHeight: '1.6'
        }}>
          All accounts and trust lines are publicly auditable on the XRP Ledger. No smart contracts, no hidden logic.
        </div>
      </div>
    </div>
  );
};

export default XRPLProofs;
